import {
  ICategoryData,
  INoticationSettingsModel,
  INotificationSettingsCategory,
  IPreference,
  IUpdatedPreference
} from '../notification_settings_interfacaes';

import * as _4 from 'lodash4';

export class NotificationSettingsModel {
  model: INoticationSettingsModel;
  trackedUpdates = new Map<string, IPreference>();

  constructor(private NotificationSettingsBuilder: any) {}

  update(data: ICategoryData): void {
    const builderData: INoticationSettingsModel = new this.NotificationSettingsBuilder(data);
    builderData.categories = _4.keyBy(builderData.categories, 'nk');
    this.model = builderData;
  }

  getAllCategories(): INotificationSettingsCategory[] {
    return _4.values(this.model.categories);
  }

  resetTrackedUpdates() {
    this.trackedUpdates.clear();
  }

  addUpdatedPreference(prefObj: IPreference) {
    if (this.trackedUpdates.has(prefObj.category_nk + prefObj.preferenceType.key)) {
      this.trackedUpdates.delete(prefObj.category_nk + prefObj.preferenceType.key);
    } else {
      this.trackedUpdates.set(prefObj.category_nk + prefObj.preferenceType.key, prefObj);
    }
  }

  updateCategoryPreference(newPreference: IUpdatedPreference): INotificationSettingsCategory {
    const updated: INotificationSettingsCategory = this.model.categories[newPreference.category];

    if (updated) {
      updated.preferences[newPreference.channel].status = newPreference.is_active;
    }
    return updated;
  }

  updatePreferenceFromServer(serverData: any) {
    return this.updateCategoryPreference(serverData.preference[_4.first(_4.keys(serverData.preference))]);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/models/notification_settings_model.ts